/* eslint-disable react-hooks/exhaustive-deps */
import { FC, ReactNode, useEffect, useState } from "react";
import { LocalStorage } from "src/framework/commons/LocalStorage";
import { PermissionUtil } from "src/framework/commons/PermissionUtil";
import { InputComboBox } from "src/framework/components/forms/inputs/InputComboBox";
import { InputComboBoxList } from "src/framework/components/forms/inputs/InputComboBoxList";
import { InputInfo } from "src/framework/components/forms/inputs/InputInfo/InputInfo";
import { authUser$ } from "src/framework/components/navigations/MenuUser";
import { IDataResponse, STATUS_CODE, apiNoLoading } from "src/framework/providers/api";
import { confirmationDialog } from "src/framework/store/ConfirmationDialogStore";
import { notifierStore } from "src/framework/store/NotifierStore";
import { useObservable } from "src/framework/store/storeUtil";
import { ProjetosDescontosProvider } from "src/providers/ProjetosDescontosProvider";
import { ProjetosDescontosLista, ProjetosDescontosRequest } from "src/providers/ProjetosDescontosProvider/types";
import { CacheType, contaUsuario$ } from "src/store/global.store";
import { ContaUsuario } from "src/store/global.store.types";
import { useProjetoPersonalizadoHibridoStore } from "src/store/vendas/projetos/personalizado_hibrido/personalizadoHibrido.store";

interface FormDistribuidorRevendaProperties {
    projetoState: any;
}

const getFilteredOptionsByNomeOrDoc = (options: any[], searchText: string) => {
    if (!searchText) return options;
    const normalizedSearch = (searchText).replace(/[^a-zA-Z0-9]/g, '')
    if (normalizedSearch && normalizedSearch.length !== 14) {
        return options.filter((item: { cnpj_cpf: string; nome: string }) => item.nome.toLowerCase()?.includes(searchText.toLowerCase()))
    }
    return options.filter((item: { cnpj_cpf: string; nome: string }) => {
      const normalizedDoc = (item.cnpj_cpf || '').replace(/[^a-zA-Z0-9]/g, '')
      return (
        (normalizedSearch && normalizedDoc?.includes(normalizedSearch))
        || item.nome.toLowerCase()?.includes(searchText.toLowerCase())
      )
    });
}

const FormDistribuidorRevenda: FC<FormDistribuidorRevendaProperties> = ({ projetoState  }) => {
    const userInfo = LocalStorage.get("solar.userExtraInfo", true);
    const contaUsuario = useObservable<CacheType<ContaUsuario | null>>(contaUsuario$);
    const { changeValue } = useProjetoPersonalizadoHibridoStore(state => state.actions)

    const [distribuidoresListState, setDistribuidoresListState] = useState<any>();
    const [elementoRevenda, setElementoRevenda] = useState<HTMLElement | null>(null);
    const projetosDescontosProvider = new ProjetosDescontosProvider();
    const authUser = useObservable(authUser$)

    const loadDistribuidores = async () => {
        let url = `/cadastros/contas/distribuidores?orderby=fantasia&segmento_in=on,todos` 
        const response: IDataResponse = await apiNoLoading.get({ url });
        if (response.statusCode === STATUS_CODE.OK) {
            setDistribuidoresListState(response.data);
        }
      }

    useEffect(() => {
        const _el = document.getElementById("combobox-revenda");
        setElementoRevenda(_el);
    }, [document.getElementById("combobox-revenda")])

    useEffect(() => {
        loadDistribuidores();
    }, []);

    const renderDistribuidor = (): ReactNode => {
        const permissions = PermissionUtil.getPermissions();

        if (PermissionUtil.can(PermissionUtil.PERMISSION_PROJETOS_VISUALIZAR_FILIAIS, permissions) && !PermissionUtil.isAdministrador(permissions) && contaUsuario?.data?.filiais?.length && contaUsuario?.data?.distribuidor?.id) {
            return (
                <InputComboBoxList
                    key={`projetos-distribuidor`}
                    label={"* Distribuidor"}
                    value={projetoState?.distribuidor}
                    options={[contaUsuario.data.distribuidor, ...contaUsuario.data.filiais]}
                    filterOptions={(opts, state) => getFilteredOptionsByNomeOrDoc(opts, state.inputValue)}
                    textField="nome"
                    disableClearable
                    valueField="id"
                    renderOptions={(option: any) => {
                        return `${option.nome} (${option.cnpj_cpf})`
                    }}
                    renderOptionsLabel={(option: any) => {
                        return `${option.nome} (${option.cnpj_cpf})`
                    }}
                    onChange={(value: any) => {
                        changeValue({ ...projetoState, distribuidor: value, distribuidor_id: value?.id || null, revenda: null, revenda_id: null });
                    }}
                />
            )
        }

        if (userInfo?.isIntelbras) {
            return (
                <InputComboBoxList
                    key={`projetos-distribuidor`}
                    label={"* Distribuidor"}
                    value={projetoState?.distribuidor}
                    options={distribuidoresListState || []}
                    filterOptions={(opts, state) => getFilteredOptionsByNomeOrDoc(opts, state.inputValue)}
                    textField="nome"
                    disableClearable
                    valueField="id"
                    renderOptions={(option: any) => {
                        return `${option.nome} (${option.cnpj_cpf})`
                    }}
                    renderOptionsLabel={(option: any) => {
                        return `${option.nome} (${option.cnpj_cpf})`
                    }}
                    onChange={(value: any) => {
                        changeValue({ ...projetoState, distribuidor: value, distribuidor_id: value?.id || null, revenda: null, revenda_id: null });
                    }}
                />
            )
        }
        const distribuidorNome = projetoState?.id ? projetoState?.distribuidor.nome : userInfo?.distribuidor_nome


        return <>
            <InputInfo
                label="Distribuidor"
                text={distribuidorNome}
            />
        </>
    }

    const consultarDescontosProjeto = async (id: any) => {
        return await projetosDescontosProvider.consultarDescontos(id);
    };

    const doSaveDescontos = async (): Promise<IDataResponse | null> => {
        const deconstosList: ProjetosDescontosLista[] = [
            {
                novoPercentual: 0,
                tipo: "distribuidor",
                novoValor: 0,
            },
            {
                novoPercentual: 0,
                tipo: "revenda",
                novoValor: 0,
            },
            {
                novoPercentual: 0,
                tipo: "intelbras",
                novoValor: 0,
                justificativa: 'Remoção de descontos devido a remoção de revenda',
            },
        ];

        const requestDesconto: ProjetosDescontosRequest = {
            descontos: deconstosList,
        }

        if (projetoState?.id) {
            const resultRequest: IDataResponse = await projetosDescontosProvider.atualizarDescontos(projetoState.id, requestDesconto);
            return resultRequest;
        }
        return null;
    }

    const renderRevenda = (): ReactNode => {
        if (userInfo?.isIntelbras || userInfo?.isDistribuidor) {
            let url = `/cadastros/contas/distribuidores/${projetoState?.distribuidor?.id || authUser?.distribuidor_id}/revendas?orderby=fantasia&segmento_in=on,todos`;
            return (
                <InputComboBox
                    disabled={(userInfo?.isDistribuidor && !authUser?.distribuidor_id) || (userInfo?.isIntelbras && !projetoState?.distribuidor?.id)}
                    key={`projetos-revenda`}
                    path={(authUser?.distribuidor_id || projetoState?.distribuidor?.id) ? url : ""}
                    label={"Revenda"}
                    provider={apiNoLoading}
                    filterOptions={(opts, state) => getFilteredOptionsByNomeOrDoc(opts, state.inputValue)}
                    value={projetoState?.revenda}
                    textField="nome"
                    valueField="id"
                    id="combobox-revenda"
                    renderOptions={(option: any) => {
                        return `${option.nome} (${option.cnpj_cpf})`
                    }}
                    renderOptionsLabel={(option: any) => {
                        return `${option.nome} (${option.cnpj_cpf})`
                    }}
                    onChange={(value: any) => {
                        if (projetoState?.id && projetoState?.revenda?.id && (value === null || projetoState?.revenda?.id !== value?.id)) {
                            const consulta = consultarDescontosProjeto(projetoState?.id);
                            consulta.then((response) => {
                                if (response?.statusCode === STATUS_CODE.OK && (response?.data?.desconto_revenda > 0 || 
                                    response?.data?.desconto_distribuidor > 0 ||
                                    response?.data?.desconto_intelbras > 0 ||
                                    response?.data?.valor_intelbras > 0)) {
                                    confirmationDialog.setup({
                                        title: "Aviso!!!",
                                        content: <>Ao realizar essa ação, todos os descontos serão removidos.</>,
                                        yesText: "Continuar",
                                        noText: "Cancelar",
                                        onClose: () => {
                                            confirmationDialog.close();
                                            elementoRevenda?.focus();
                                        },
                                        onConfirmation: () => {
                                            confirmationDialog.close();
                                            doSaveDescontos().then(response => {
                                                if (response?.statusCode === STATUS_CODE.OK) {
                                                    changeValue({ ...projetoState, revenda: value || null, revenda_id: value?.id || null });
                                                } else {
                                                    notifierStore.setNotifier({
                                                        title: "Aviso!!!",
                                                        content: ["Não foi possível alterar ou remover a revenda por ter dado falha ao remover os descontos."],
                                                        timeOut: 3500,
                                                        onClose: () => {
                                                            elementoRevenda?.focus();
                                                            notifierStore.setOpen(false);
                                                        }
                                                    });
                                                    notifierStore.setOpen(true);
                                                }
                                            });
                                        }
                                    })
                                    confirmationDialog.open();
                                } else {
                                    changeValue({ ...projetoState, revenda: value || null, revenda_id: value?.id || null });
                                }
                            })
                        } else {
                            changeValue({ ...projetoState, revenda: value || null, revenda_id: value?.id || null });
                        }
                    }}
                />
            )
        }
        const RevendaNome = projetoState?.id ? projetoState?.revenda?.nome : userInfo?.revenda_nome || ""

        return <>
            <InputInfo
                label="Revenda"
                text={RevendaNome}
            />
        </>
    }

    return <>
        <div className="row">
            <div className="X12 M6">
                {renderDistribuidor()}
            </div>
            <div className="X12 M6">
                {renderRevenda()}
            </div>
        </div>
    </>
}

export { FormDistribuidorRevenda }


